import React from 'react';
import {Button, FormControlLabel, CircularProgress, Paper, Typography, Box, Checkbox} from '@mui/material';
import * as ETVConstants from '../ETVConstants';
import { Save } from '@mui/icons-material';

class ConnectFloorWithDisplays extends React.Component {

	constructor(props) {
      	super(props);
    }

    state = {
		deviceIDs:[],
		isLoaded:false,
		originalDeviceIDs: [],
    }

	componentDidUpdate() {
      if(!this.state.isLoaded) {
        this.loadConnectedDisplays();
      }
	}

    componentDidMount() {
		this.loadConnectedDisplays();
    }

    loadConnectedDisplays() {
		var accessToken = localStorage.getItem("etv.access_token");
      	var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/floor_access?action=get_connected_device_ids&floor_id="+this.props.floor_id;
		//console.log("url load all connected deviceIDs="+url);
	    fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            const list = result.list || [];
			this.setState({
				deviceIDs: list,
				originalDeviceIDs: list,
				isLoaded: true,
			});
          },
          (error) => {
            this.setState({
              deviceIDs:[],
			  originalDeviceIDs: [],
              isLoaded: false,
              error
            });
          }
        )
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

	hasChanges() {
		const { deviceIDs, originalDeviceIDs } = this.state;
		if (deviceIDs.length !== originalDeviceIDs.length) return true;
		const sortedA = [...deviceIDs].sort();
		const sortedB = [...originalDeviceIDs].sort();
		return !sortedA.every((val, i) => val === sortedB[i]);
	}

	saveConnectedDisplays() {
		var accessToken = localStorage.getItem("etv.access_token");
      	var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/floor_access?action=set_connected_devices";
		url+="&floor_id="+this.props.floor_id;
		var deviceIDs = this.state.deviceIDs;
		for(var i=0; i<deviceIDs.length; i++) {
			url+="&device_id="+encodeURIComponent(deviceIDs[i]);
		}
		fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then((result) => {
			this.setState({isLoaded:false});
		})
		.catch((error) => {
			this.showInfoMessage("Error", "Failed to save floor");
		});
	}

	render() {
		const { all_devices } = this.props;
		const { deviceIDs, isLoaded } = this.state;

		if (!isLoaded) {
			return (
				<Box display="flex" justifyContent="center" alignItems="center" height={200}>
					<CircularProgress />
				</Box>
			);
		}

		const isChecked = (device_id) => deviceIDs.includes(device_id);

		const toggleDevice = (device_id) => {
			const updated = isChecked(device_id)
				? deviceIDs.filter(id => id !== device_id)
				: [...deviceIDs, device_id];
			this.setState({ deviceIDs: updated });
		};

		const selectAll = () => {
			const allIDs = all_devices.map(dev => dev.device_id);
			this.setState({ deviceIDs: allIDs });
		};

		const deselectAll = () => {
			this.setState({ deviceIDs: [] });
		};

		return (
			<div>
				<Typography variant="h2" gutterBottom>
					{this.props.floor_label}
				</Typography>

				<Typography variant="body2" gutterBottom>
					{ETVConstants.trans("desc_serving_floors")}
				</Typography>

				<Box display="flex" gap={2} mb={2}>
					<Button variant="outlined" onClick={selectAll}>
						{ETVConstants.trans("select_all")}
					</Button>
					<Button variant="outlined" onClick={deselectAll}>
						{ETVConstants.trans("deselect_all")}
					</Button>
				</Box>

				<Box
					sx={{
						maxHeight: 300,
						overflowY: 'auto',
						border: '1px solid #ccc',
						borderRadius: 1,
						p: 2,
						mb: 2,
					}}
				>
					{all_devices.map((device) => (
						<FormControlLabel
							key={device.device_id}
							control={
								<Checkbox
									checked={isChecked(device.device_id)}
									onChange={() => toggleDevice(device.device_id)}
								/>
							}
							label={device.device_name}
						/>
					))}
				</Box>

				<Button
					variant="contained"
					color="primary"
					startIcon={<Save />}
					onClick={() => this.saveConnectedDisplays()}
					disabled={!this.hasChanges()}
				>
					{ETVConstants.trans("save")}
				</Button>

			</div>
		);
	}

}

export default ConnectFloorWithDisplays;